<template>
  <div class="user-container">
    <div class="table-fields">
      <div style="width:100%;display:flex;flex-direction:row;align-items:center;">
        <label style="margin:0 30px;">用户名:</label>
        <el-input style="width:200px;" v-model="params.userName" placeholder="请输入用户名"></el-input>
        <el-button style="margin:0 30px;" type="primary" @click="handleSearch">搜索</el-button>
        <el-button type="warning" @click="dialogVisible = true">
          新增
          <i class="el-icon-plus el-icon--right"></i>
        </el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0'}"
      style="width: 100%"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
    >
      <el-table-column prop="userName" label="帐号"></el-table-column>
      <el-table-column prop="mobile" label="手机号"></el-table-column>
      <el-table-column prop="name" label="真实姓名"></el-table-column>

      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === `1`" type="danger">未启用</el-tag>
          <el-tag v-if="scope.row.status === `2`" type="success">已启用</el-tag>
          <el-tag v-if="scope.row.status === `3`" type="warning">已禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建日期"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleClickActive(scope.row.userName)"
            type="success"
            size="mini"
            icon="el-icon-caret-right"
            v-if="scope.row.status   != `2` "
          >启用</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handlDelete(scope.row.userName)"
            v-if="scope.row.status === `2`"
            size="mini"
          >禁用</el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handlUpdate(scope.row.userName)"
            size="mini"
          >改密</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="params.limit"
      style="margin-top:30px;"
      background
      layout="total,prev, pager, next"
      :total="total"
      @current-change="handleClickPage"
    ></el-pagination>
    <el-dialog title="新增管理员" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form">
        <el-form-item label="用户名称" :label-width="formLabelWidth">
          <el-input v-model="form.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="form.password" autocomplete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机" :label-width="formLabelWidth">
          <el-input v-model="form.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="操作员角色">
          <el-select style="width:300px;" v-model="form.roleId" placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCommit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="dialogUpdateVisible" width="500px">
      <el-form :model="form">
        <el-form-item label="用户名称" :label-width="formLabelWidth">
          <el-input v-model="updateVO.userName" :disabled="true" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="原始密码" :label-width="formLabelWidth">
          <el-input v-model="updateVO.oldPassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input v-model="updateVO.newPassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth">
          <el-input v-model="updateVO.confirmPassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogUpdateVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCommitUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserList,
  addUser,
  activeUser,
  forbidUser,
  updatePassword,
  roleActiveList
} from "@/axios/api";
export default {
  data() {
    return {
      tableData: [],
      params: {
        page: 1,
        limit: 30,
        userName: ""
      },
      total: 0,
      dialogVisible: false,
      dialogUpdateVisible: false,
      formLabelWidth: "80px",
      form: {
        userName: "",
        password: "",
        name: "",
        mobile: "",
        roleId: ''
      },
      updateVO: {
        userName: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      roleList:[]
    };
  },
  methods: {
    getRoleActiveList(){
      roleActiveList().then(res => {
        this.roleList = res.data;
      })
    },
    handlUpdate(userName) {
      this.updateVO.userName = userName;
      this.dialogUpdateVisible = true;
    },
    handleCommitUpdate() {
      updatePassword(this.updateVO).then(res => {
        if (res.status === 200) {
          this.$message.success("修改成功");
          this.dialogUpdateVisible = false;
        }
      });
    },
    handlDelete(userName) {
      forbidUser({ userName: userName }).then(res => {
        if (res.status === 200) {
          this.$message.success("禁用成功");
          this.handleUserList();
        }
      });
    },
    handleClickActive(userName) {
      activeUser({ userName: userName }).then(res => {
        if (res.status === 200) {
          this.$message.success("启用成功");
          this.handleUserList();
        }
      });
    },
    handleCommit() {
      addUser(this.form).then(res => {
        if (res.status === 200) {
          this.$message.success("新增成功");
          this.dialogVisible = false;
          this.params.page = 1;
          this.handleUserList();
        }
      });
    },
    handleSearch() {
      this.params.page = 1;
      this.handleUserList();
    },
    handleUserList() {
      getUserList(this.params).then(res => {
        if (res.status === 200) {
          this.tableData = res.records;
          this.total = res.total;
        }
      });
    },
    handleClickPage(event) {
      this.params.page = event;
      this.handleUserList();
    }
  },
  mounted() {
    this.handleUserList();
    this.getRoleActiveList();
  }
};
</script>

<style>
.table-field .el-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-fields {
  width: 100%;
  height: 80px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 50px;
  box-sizing: border-box;
  padding: 30px;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/user/User.vue